import { useQuery } from "@tanstack/react-query"
import type { CustomerResponse } from "@/shared/api/types/CustomerResponse"
import { useCmApi } from "@/shared/hooks/useCmApi"

const QUERY_KEY = "customer"

export const useGetCustomer = (customerId: string, enabled?: boolean) => {
  const cmApi = useCmApi()
  const { data, isLoading, error, isError, refetch } = useQuery<CustomerResponse | null>({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => (customerId ? cmApi.getCustomer(customerId) : null),
    placeholderData: (prev?: CustomerResponse | null) => prev,
    enabled
  })

  return { data, isLoading, error, isError, refetch }
}
